// extracted by mini-css-extract-plugin
module.exports = {"breakpoint-tablet":"(min-width: 520px)","resultsSummary":"ResultsSummary-module--resultsSummary--69bb6c"};